import { render, staticRenderFns } from "./EvalEvaluations.vue?vue&type=template&id=0bc8120f&scoped=true"
import script from "./EvalEvaluations.vue?vue&type=script&lang=js"
export * from "./EvalEvaluations.vue?vue&type=script&lang=js"
import style0 from "./EvalEvaluations.vue?vue&type=style&index=0&id=0bc8120f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8120f",
  null
  
)

export default component.exports